export default "__VITE_ASSET__DYczysps__"